<template>
  <div :class="['v-radio']">
    <label class="v-radio__wrapper">
      <input class="v-radio__input" type="radio" v-bind="$attrs" :checked="checked" />
      <div class="v-radio__radio"></div>
      <span class="v-radio__label">{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-radio {
  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    user-select: none;
  }

  &__input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;

    &:checked ~ .v-radio__radio {
      background: #0084ff;
      border-color: #0084ff;

      &::before {
        background: #fff;
      }
    }

    &:checked:disabled ~ .v-radio__radio {
      background: #fff;
      border-color: #b8b8b8;

      &::before {
        background: #b8b8b8;
      }
    }

    &:checked ~ .v-radio__label {
      color: inherit;
    }

    &:checked:disabled ~ .v-radio__label {
      color: #b8b8b8;
    }
  }

  &__radio {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    background: #fff;
    border: 1px solid #b8b8b8;

    &::before {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 100%;
    }
  }

  &__label {
    margin-left: $spacer;
    color: #939393;
  }
}
</style>
